import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, filter, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  isLoading = new BehaviorSubject<boolean>(false);
  
  constructor(private router: Router) {
    this.router.events.pipe(filter(event => 
      event instanceof NavigationStart ||
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    )).subscribe(event => {
      if (event instanceof NavigationStart) {
        let fullUrl = this.router.url
        let path: string = fullUrl.split('/')[1].split('?')[0];// get current jti from route.
        if (path === 'app-initialization') this.stopLoading();
        else this.showLoading();
      }
      else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.stopLoading();
        return;
      }
      else {
        this.stopLoading();
        return;
      }
    });
  }  

  showLoading() {
    // logic
    this.isLoading.next(true);
  }

  stopLoading() {
    this.isLoading.next(false);
  }

  loadingStatus() {
    return this.isLoading.asObservable();
  }
}
